import DatePicker from '@/Components/Common/DatePicker'
import React, { useRef, useState } from 'react'
import { Form, FormControl, FormField, FormItem, FormLabel } from '@/Components/ui/form'
import { Input } from '@/Components/ui/input'
import SearchableDropdown from '@/Components/Common/SearchableDropdown'
import { Popover, PopoverContent, PopoverTrigger } from '@/Components/ui/popover'
import { format, setDate } from 'date-fns'
import { CalendarIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Calendar } from '@/Components/ui/calendar'
import { ScrollArea, ScrollBar } from '@/Components/ui/scroll-area'
import { Button } from '@/Components/ui/button'
import Constant from '@/utils/Constant'
import DateTimePicker from '@/Components/Common/DateTimePicker'
import { Textarea } from '@/Components/ui/textarea'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/Components/ui/table'
import { Checkbox } from '@/Components/ui/checkbox'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import NoDataFound from '@/Components/Common/NoDataFound'
import { toast } from 'react-toastify'
import WorkAllocationFormService from '@/Service/WorkAllocationFormService'

const Coding = ({ form, event, updateEvent, category, subCategory }) => {
    const scrollRef = useRef()
    const scrollRef_qa = useRef()
    const dragItem = useRef(null)
    const dragOverItem = useRef(null)
    const getSubcategories = (coding_category) => {
        const subc = subCategory?.filter((sub) => sub.coding_category === coding_category)
        return subc
    }

    const handlePaste = (e, rowIndex) => {
        e.preventDefault()
        const pasted = e.clipboardData.getData('Text')

        if (!pasted) return

        const lines = pasted
            .split('\n')
            .map((line) => line.trim())
            .filter((line) => line.length > 0)

        if (lines.length === 0) return

        const existing = [...event.work_allocation.m1023_other_secondary_diagnosis]

        // Copy existing and update starting at rowIndex
        let updatedRows = existing.map((row, idx) => {
            if (idx >= rowIndex && idx < rowIndex + lines.length) {
                return { ...row, first_diagnostics: lines[idx - rowIndex].toUpperCase() }
            }
            return row
        })

        // If not enough rows, append new ones
        const extras = lines.slice(Math.max(0, existing.length - rowIndex))
        extras.forEach((line, i) => {
            updatedRows.push({
                idx: updatedRows.length + 1,
                first_diagnostics: line.toUpperCase(),
                checkbox: false,
            })
        })

        updateEvent({
            work_allocation: {
                ...event.work_allocation,
                m1023_other_secondary_diagnosis: updatedRows,
            },
            update_obj: {
                name: event?.work_allocation?.name,
                data: {
                    m1023_other_secondary_diagnosis: updatedRows,
                },
            },
        })
    }

    const handlePaste_qa = (e, rowIndex) => {
        e.preventDefault()
        const pasted = e.clipboardData.getData('Text')

        if (!pasted) return

        const lines = pasted
            .split('\n')
            .map((line) => line.trim())
            .filter((line) => line.length > 0)

        if (lines.length === 0) return

        const existing = [...event.work_allocation.secondary_diagnostics_qa_feedback]

        // Copy existing and update starting at rowIndex
        let updatedRows = existing.map((row, idx) => {
            if (idx >= rowIndex && idx < rowIndex + lines.length) {
                return { ...row, icd_qa: lines[idx - rowIndex] }
            }
            return row
        })

        // Append new rows if there are more lines than existing rows
        const extraLines = lines.slice(Math.max(0, existing.length - rowIndex))
        extraLines.forEach((line, i) => {
            updatedRows.push({
                idx: updatedRows.length + 1,
                checkbox: false,
                icd_qa: line,
                coding_category: '',
                coding_subcategory: '',
                qa_comments: '',
                educational_error: false,
            })
        })

        updateEvent({
            work_allocation: {
                ...event.work_allocation,
                secondary_diagnostics_qa_feedback: updatedRows,
            },
            update_obj: {
                name: event?.work_allocation?.name,
                data: {
                    secondary_diagnostics_qa_feedback: updatedRows,
                },
            },
        })
    }

    const handleDragStart = (index) => {
        dragItem.current = index
    }

    const handleDragEnter = (index) => {
        dragOverItem.current = index
    }

    const handleDrop = () => {
        const copyListItems = [...event.work_allocation.m1023_other_secondary_diagnosis]

        const draggedItem = copyListItems[dragItem.current]

        // Remove dragged item
        copyListItems.splice(dragItem.current, 1)

        // Insert at new position
        copyListItems.splice(dragOverItem.current, 0, draggedItem)

        // Optionally reassign IDs or Sr. No
        const reordered = copyListItems.map((item, index) => ({
            ...item,
            idx: index + 1, // Reassign Sr. No based on order if needed
        }))

        // Reset refs
        dragItem.current = null
        dragOverItem.current = null

        // Update state
        //seticdRow(reordered)
        updateEvent({
            work_allocation: {
                ...event.work_allocation,
                m1023_other_secondary_diagnosis: reordered,
            },
            update_obj: {
                name: event?.work_allocation?.name,
                data: {
                    m1023_other_secondary_diagnosis: reordered,
                },
            },
        })
    }
    const handleDragStart_qa = (index) => {
        dragItem.current = index
    }

    const handleDragEnter_qa = (index) => {
        dragOverItem.current = index
    }

    const handleDrop_qa = () => {
        const copyListItems = [...event.work_allocation.secondary_diagnostics_qa_feedback]

        const draggedItem = copyListItems[dragItem.current]

        // Remove dragged item
        copyListItems.splice(dragItem.current, 1)

        // Insert at new position
       
        copyListItems.splice(dragOverItem.current, 0, draggedItem)
        if (dragOverItem.current == 0) {
            return
        }

        // Optionally reassign IDs or Sr. No
        const reordered = copyListItems.map((item, index) => ({
            ...item,
            idx: index + 1, // Reassign Sr. No based on order if needed
        }))

        // Reset refs
        dragItem.current = null
        dragOverItem.current = null

        // Update state
        //seticdRow(reordered)
        updateEvent({
            work_allocation: {
                ...event.work_allocation,
                secondary_diagnostics_qa_feedback: reordered,
            },
        })
    }

    return (
        <>
            <div className="grid grid-cols-3 gap-y-3 gap-x-6 mt-5">
                <FormField
                    control={form.control}
                    name="assessment_date"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel required={true}>Assessment Date</FormLabel>
                            <FormControl>
                                <DatePicker
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="Payor Type"
                                    date={event.work_allocation.assessment_date}
                                    handleChange={(e) =>
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                assessment_date: e,
                                            },
                                            update_obj: {
                                                name: event?.work_allocation?.name,
                                                data: {
                                                    assessment_date: e,
                                                },
                                            },
                                        })
                                    }
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="gender"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel required={true}>Gender</FormLabel>
                            <FormControl>
                                <SearchableDropdown
                                    options={[
                                        { gender: 'Male', name: 'Male' },
                                        { gender: 'Female', name: 'Female' },
                                    ]}
                                    selectedVal={event?.work_allocation?.gender}
                                    handleChange={(val) =>
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                gender: val,
                                            },
                                            update_obj: {
                                                name: event?.work_allocation?.name,
                                                data: {
                                                    gender: val,
                                                },
                                            },
                                        })
                                    }
                                    label="gender"
                                    placeholder="Select Gender"
                                    disabled={false}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
                {event.work_allocation.assessment_type == 'SOC' && (
                    <FormField
                        control={form.control}
                        name="f2f"
                        render={({ field }) => (
                            <FormItem className="space-y-1">
                                <FormLabel required={true}>F2F</FormLabel>
                                <FormControl>
                                    <SearchableDropdown
                                        options={[
                                            { f2f: 'Yes', name: 'Yes' },
                                            { f2f: 'No', name: 'No' },
                                        ]}
                                        selectedVal={event?.work_allocation?.gender}
                                        handleChange={(val) =>
                                            updateEvent({
                                                work_allocation: {
                                                    ...event.work_allocation,
                                                    f2f: val,
                                                },
                                                update_obj: {
                                                    name: event?.work_allocation?.name,
                                                    data: {
                                                        f2f: val,
                                                    },
                                                },
                                            })
                                        }
                                        label="f2f"
                                        placeholder="Select F2F"
                                        disabled={false}
                                    />
                                </FormControl>
                            </FormItem>
                        )}
                    />
                )}
            </div>
            <Table className="mt-4 mb-2 ">
                <TableHeader className="bg-purple-100">
                    <TableHead className="text-purple-950 font-semibold text-[12px]">Medical Coder</TableHead>
                    <TableHead className="text-purple-950 font-semibold text-[12px]">QA Feedback</TableHead>
                    <TableHead className="text-purple-950 font-semibold text-[12px]">QA Comment</TableHead>
                </TableHeader>
                <TableBody>
                    <TableRow>
                        <TableCell className="width-1/3 ">
                            <FormField
                                control={form.control}
                                name="pdpc_coder"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel className="text-[12px] font-normal" required={true}>
                                            PDPC- Huddle Note or Care Coordination Note Present?
                                        </FormLabel>
                                        <FormControl>
                                            <SearchableDropdown
                                                options={[{ pdpc: 'Yes' }, { pdpc: 'No' }, { pdpc: 'NA' }]}
                                                selectedVal={event.work_allocation.pdpc}
                                                handleChange={(val) =>
                                                    updateEvent({
                                                        work_allocation: {
                                                            ...event.work_allocation,
                                                            pdpc: val,
                                                        },
                                                        update_obj: {
                                                            name: event?.work_allocation?.name,
                                                            data: {
                                                                pdpc: val,
                                                            },
                                                        },
                                                    })
                                                }
                                                label="pdpc"
                                                placeholder=""
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />
                        </TableCell>
                        <TableCell className="">
                            <FormField
                                control={form.control}
                                name="pdpc_qa"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel className="text-[12px] font-normal">
                                            PDPC- Huddle Note or Care Coordination Note Present?
                                        </FormLabel>
                                        <FormControl>
                                            <SearchableDropdown
                                                options={[{ pdpc: 'Yes' }, { pdpc: 'No' }, { pdpc: 'NA' }]}
                                                selectedVal={event.work_allocation.qapdpc}
                                                handleChange={(val) =>
                                                    updateEvent({
                                                        work_allocation: {
                                                            ...event.work_allocation,
                                                            qapdpc: val,
                                                        },
                                                        update_obj: {
                                                            name: event?.work_allocation?.name,
                                                            data: {
                                                                qapdpc: val,
                                                            },
                                                        },
                                                    })
                                                }
                                                label="pdpc"
                                                placeholder=""
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />
                        </TableCell>
                        <TableCell className="">
                            <FormField
                                control={form.control}
                                name="qa_pdpc_comments"
                                render={({ field }) => (
                                    <FormItem className="flex flex-col mt-1">
                                        <Textarea
                                            className="resize-none shadow-none  focus-visible:ring-transparent"
                                            rows="2"
                                            value={event.work_allocation.qa_pdpc_comments}
                                            onChange={(e) =>
                                                updateEvent({
                                                    work_allocation: {
                                                        ...event.work_allocation,
                                                        qa_pdpc_comments: e.target.value,
                                                    },
                                                    update_obj: {
                                                        name: event?.work_allocation?.name,
                                                        data: {
                                                            qa_pdpc_comments: e.target.value,
                                                        },
                                                    },
                                                })
                                            }
                                        />
                                    </FormItem>
                                )}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow className="mb-2">
                        <TableCell className="w-1/3 ">
                            <FormField
                                control={form.control}
                                name="no_of_pages"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel className="text-[12px] font-normal" required={true}>
                                            No of Pages
                                        </FormLabel>
                                        <FormControl>
                                            <Input
                                                type="number"
                                                className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                                placeholder="No of pages"
                                                value={event?.work_allocation?.no_of_pages}
                                                onChange={(e) =>
                                                    updateEvent({
                                                        work_allocation: {
                                                            ...event.work_allocation,
                                                            no_of_pages: e.target.value,
                                                        },
                                                        update_obj: {
                                                            name: event?.work_allocation?.name,
                                                            data: {
                                                                no_of_pages: e.target.value,
                                                            },
                                                        },
                                                    })
                                                }
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />
                        </TableCell>
                        <TableCell className="">
                            <FormField
                                control={form.control}
                                name="no_of_pages_qa"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel className="text-[12px] font-normal">No of Pages</FormLabel>
                                        <FormControl>
                                            <Input
                                                type="number"
                                                className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                                placeholder="No of pages"
                                                value={event.work_allocation.qa_no_of_pages}
                                                onChange={(e) =>
                                                    updateEvent({
                                                        work_allocation: {
                                                            ...event.work_allocation,
                                                            qa_no_of_pages: e.target.value,
                                                        },
                                                        update_obj: {
                                                            name: event?.work_allocation?.name,
                                                            data: {
                                                                qa_no_of_pages: e.target.value,
                                                            },
                                                        },
                                                    })
                                                }
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />
                        </TableCell>
                        <TableCell className="">
                            <FormField
                                control={form.control}
                                name="qa_no_of_pages_comments"
                                render={({ field }) => (
                                    <FormItem className=" mt-1">
                                        <Textarea
                                            className="resize-none  shadow-none focus-visible:ring-transparent"
                                            rows="2"
                                            value={event?.work_allocation?.qa_no_of_pages_comments}
                                            onChange={(e) =>
                                                updateEvent({
                                                    work_allocation: {
                                                        ...event.work_allocation,
                                                        qa_no_of_pages_comments: e.target.value,
                                                    },
                                                    update_obj: {
                                                        name: event?.work_allocation?.name,
                                                        data: {
                                                            qa_no_of_pages_comments: e.target.value,
                                                        },
                                                    },
                                                })
                                            }
                                        />
                                    </FormItem>
                                )}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className=" p-2 align-baseline">
                            <h5 className="font-semibold">ICD Code</h5>
                            <Table className="border border-gray-200 w-[97%]">
                                <TableHeader>
                                    <TableHead className="text-[12px] font-semibold border border-gray-200">
                                        <Checkbox
                                            className="mx-2"
                                            onClick={() => {
                                                const allChecked = !event.work_allocation.m1023_other_secondary_diagnosis.every(
                                                    (icd_code) => icd_code.checkbox
                                                )
                                                updateEvent({
                                                    work_allocation: {
                                                        ...event.work_allocation,
                                                        m1023_other_secondary_diagnosis: event.work_allocation.m1023_other_secondary_diagnosis.map(
                                                            (icd_code) => ({
                                                                ...icd_code,
                                                                checkbox: allChecked,
                                                            })
                                                        ),
                                                    },
                                                })
                                            }}
                                            checked={
                                                event?.work_allocation?.m1023_other_secondary_diagnosis?.length > 0 &&
                                                event?.work_allocation?.m1023_other_secondary_diagnosis?.every((row) => row.checkbox)
                                            }
                                        />
                                    </TableHead>
                                    <TableHead className="text-[12px] font-semibold border border-gray-200 w-[70px]">Sr. No</TableHead>
                                    <TableHead className="text-[12px] font-semibold border border-gray-200">ICD Code</TableHead>
                                </TableHeader>
                                {event?.work_allocation.m1023_other_secondary_diagnosis?.length > 0 ? (
                                    event?.work_allocation.m1023_other_secondary_diagnosis?.map((row, index) => (
                                        <TableRow
                                            key={row.idx}
                                            draggable
                                            onDragStart={() => handleDragStart(index)}
                                            onDragEnter={() => handleDragEnter(index)}
                                            onDragOver={(e) => {
                                                e.preventDefault()

                                                const { clientY } = e
                                                const scrollSpeed = 20
                                                const scrollMargin = 50

                                                clearInterval(scrollRef.current)

                                                if (clientY < scrollMargin) {
                                                    scrollRef.current = setInterval(() => {
                                                        window.scrollBy(0, -scrollSpeed)
                                                    }, 16)
                                                } else if (clientY > window.innerHeight - scrollMargin) {
                                                    scrollRef.current = setInterval(() => {
                                                        window.scrollBy(0, scrollSpeed)
                                                    }, 16)
                                                }
                                            }}
                                            onDrop={(e) => {
                                                clearInterval(scrollRef.current)
                                                handleDrop(e)
                                            }}
                                            onDragLeave={() => clearInterval(scrollRef.current)}
                                            className="cursor-move"
                                        >
                                            <TableCell className="border border-gray-200">
                                                <Checkbox
                                                    className="mx-2"
                                                    checked={row.checkbox}
                                                    onClick={() =>
                                                        updateEvent({
                                                            work_allocation: {
                                                                ...event.work_allocation,
                                                                m1023_other_secondary_diagnosis:
                                                                    event.work_allocation?.m1023_other_secondary_diagnosis.map((icd_code) => {
                                                                        console.log('checkbox', icd_code.checkbox, icd_code)
                                                                        return icd_code.idx === row.idx
                                                                            ? { ...icd_code, checkbox: !icd_code.checkbox }
                                                                            : icd_code
                                                                    }),
                                                            },
                                                        })
                                                    }
                                                />
                                            </TableCell>
                                            <TableCell className="border border-gray-200">{index + 1}</TableCell>
                                            <TableCell className="border border-gray-200 p-0">
                                                <Input
                                                    className="border-none shadow-none w-full"
                                                    value={row.first_diagnostics}
                                                    onPaste={(e) => handlePaste(e, index)}
                                                    onChange={(e) => {
                                                        const updatedList = event.work_allocation.m1023_other_secondary_diagnosis.map((icdRow) =>
                                                            icdRow.idx === row.idx
                                                                ? { ...icdRow, first_diagnostics: e.target.value.toUpperCase() }
                                                                : icdRow
                                                        )

                                                        updateEvent({
                                                            work_allocation: {
                                                                ...event.work_allocation,
                                                                m1023_other_secondary_diagnosis: updatedList,
                                                            },
                                                            update_obj: {
                                                                name: event?.work_allocation?.name,
                                                                data: {
                                                                    m1023_other_secondary_diagnosis: updatedList,
                                                                },
                                                            },
                                                        })
                                                    }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow colspan={7}>
                                        <TableCell colspan={7}>
                                            <NoDataFound />
                                        </TableCell>
                                    </TableRow>
                                )}
                            </Table>
                            <Button
                                type="button"
                                className=" hover:bg-gray-200 bg-gray-200 border-gray-800 text-gray-600 text-[12px]"
                                onClick={() => {
                                    updateEvent({
                                        work_allocation: {
                                            ...event.work_allocation,
                                            m1023_other_secondary_diagnosis: [
                                                ...event?.work_allocation?.m1023_other_secondary_diagnosis,
                                                {
                                                    idx: parseInt(event?.work_allocation?.m1023_other_secondary_diagnosis.length) + 1,
                                                    checkbox: false,
                                                    first_diagnostics: '',
                                                },
                                            ],
                                        },
                                    })
                                }}
                            >
                                Add Row
                            </Button>
                            {event?.work_allocation?.m1023_other_secondary_diagnosis?.some((row) => row.checkbox) &&
                                !event?.work_allocation?.m1023_other_secondary_diagnosis?.every((row) => row.checkbox) && (
                                    <Button
                                        type="button"
                                        className="bg-primary-red ml-1 font-normal"
                                        onClick={() => {
                                            updateEvent({
                                                work_allocation: {
                                                    ...event.work_allocation,
                                                    m1023_other_secondary_diagnosis: event?.work_allocation?.m1023_other_secondary_diagnosis.filter(
                                                        (row) => !row.checkbox
                                                    ),
                                                },
                                            })
                                        }}
                                    >
                                        Delete
                                    </Button>
                                )}

                            {event?.work_allocation?.m1023_other_secondary_diagnosis?.length > 0 &&
                                event?.work_allocation?.m1023_other_secondary_diagnosis?.every((row) => row.checkbox) && (
                                    <Button
                                        type="button"
                                        className="bg-primary-red ml-1 font-normal"
                                        onClick={() => {
                                            updateEvent({
                                                work_allocation: {
                                                    ...event.work_allocation,
                                                    m1023_other_secondary_diagnosis: [],
                                                },
                                                update_obj: {
                                                    name: event.work_allocation.name,
                                                    data: {
                                                        m1023_other_secondary_diagnosis: [],
                                                    },
                                                },
                                            })
                                        }}
                                    >
                                        Delete All
                                    </Button>
                                )}
                        </TableCell>
                        <TableCell colspan={2} className="p-2 align-baseline">
                            <h5 className="font-semibold">ICD Code (QA Feedback)</h5>

                            <Table className="border border-gray-200 ">
                                <TableHeader>
                                    <TableHead className="text-[12px] font-semibold border border-gray-200 px-0 mx-2">
                                        <Checkbox
                                            className="mx-2"
                                            onClick={() => {
                                                const allChecked = !event.work_allocation?.secondary_diagnostics_qa_feedback.every(
                                                    (icd_code_qa) => icd_code_qa.checkbox
                                                )
                                                updateEvent({
                                                    work_allocation: {
                                                        ...event.work_allocation,
                                                        secondary_diagnostics_qa_feedback:
                                                            event.work_allocation.secondary_diagnostics_qa_feedback.map((icd_code_qa) => ({
                                                                ...icd_code_qa,
                                                                checkbox: allChecked,
                                                            })),
                                                    },
                                                })
                                            }}
                                            checked={
                                                event?.work_allocation?.secondary_diagnostics_qa_feedback?.length > 0 &&
                                                event?.work_allocation?.secondary_diagnostics_qa_feedback?.every((row) => row.checkbox)
                                            }
                                        />
                                    </TableHead>
                                    <TableHead className="text-[12px] font-semibold border border-gray-200 w-[70px]">Sr. No</TableHead>
                                    <TableHead className="text-[12px] font-semibold border border-gray-200">ICD Code</TableHead>
                                    <TableHead className="text-[12px] font-semibold border border-gray-200">Coding Categoty</TableHead>
                                    <TableHead className="text-[12px] font-semibold border border-gray-200">Coding Subcategory</TableHead>
                                    <TableHead className="text-[12px] font-semibold border border-gray-200">Comments</TableHead>
                                    <TableHead className="text-[12px] font-semibold border border-gray-200 width-[180px]">
                                        Educational Error
                                    </TableHead>
                                </TableHeader>
                                <TableBody>
                                    {event?.work_allocation?.secondary_diagnostics_qa_feedback?.length > 0 ? (
                                        event?.work_allocation?.secondary_diagnostics_qa_feedback?.map((row, index) => (
                                            <TableRow
                                                key={row.idx}
                                                draggable
                                                onDragStart={() => handleDragStart_qa(index)}
                                                onDragEnter={() => handleDragEnter_qa(index)}
                                                // Important!
                                                onDragOver={(e) => {
                                                    e.preventDefault()

                                                    const { clientY } = e
                                                    const scrollSpeed = 20
                                                    const scrollMargin = 50

                                                    clearInterval(scrollRef_qa.current)

                                                    if (clientY < scrollMargin) {
                                                        scrollRef_qa.current = setInterval(() => {
                                                            window.scrollBy(0, -scrollSpeed)
                                                        }, 16)
                                                    } else if (clientY > window.innerHeight - scrollMargin) {
                                                        scrollRef_qa.current = setInterval(() => {
                                                            window.scrollBy(0, scrollSpeed)
                                                        }, 16)
                                                    }
                                                }}
                                                onDrop={(e) => {
                                                    clearInterval(scrollRef_qa.current)
                                                    handleDrop_qa(e)
                                                }}
                                                onDragLeave={() => clearInterval(scrollRef_qa.current)}
                                                className="cursor-move"
                                            >
                                                <TableCell className="border border-gray-200 text-center px-0">
                                                    <Checkbox
                                                        className="mx-2 "
                                                        checked={row.checkbox}
                                                        onClick={() =>
                                                            updateEvent({
                                                                work_allocation: {
                                                                    ...event.work_allocation,
                                                                    secondary_diagnostics_qa_feedback:
                                                                        event.work_allocation.secondary_diagnostics_qa_feedback?.map((icd_code_qa) =>
                                                                            icd_code_qa.idx === row.idx
                                                                                ? { ...icd_code_qa, checkbox: !icd_code_qa.checkbox }
                                                                                : icd_code_qa
                                                                        ),
                                                                },
                                                            })
                                                        }
                                                    />
                                                </TableCell>
                                                <TableCell className="border border-gray-200 text-center">{index + 1}</TableCell>
                                                <TableCell className="border border-gray-200 p-0">
                                                    <Input
                                                        className=" outline-none ring-0 focus-visible:ring-0 border-none shadow-none w-full"
                                                        value={row.icd_qa}
                                                        onPaste={(e) => handlePaste_qa(e, index)}
                                                        onChange={(e) => {
                                                            const updatedList = event.work_allocation.secondary_diagnostics_qa_feedback?.map(
                                                                (icdRow) =>
                                                                    icdRow.idx === row.idx
                                                                        ? { ...icdRow, icd_qa: e.target.value.toUpperCase() }
                                                                        : icdRow
                                                            )
                                                            updateEvent({
                                                                work_allocation: {
                                                                    ...event.work_allocation,
                                                                    secondary_diagnostics_qa_feedback: updatedList,
                                                                },
                                                                update_obj: {
                                                                    name: event?.work_allocation?.name,
                                                                    data: {
                                                                        secondary_diagnostics_qa_feedback: updatedList,
                                                                    },
                                                                },
                                                            })
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell className="border border-gray-200 p-0 ">
                                                    <SearchableDropdown
                                                        selectedVal={row.idx === 1 ? 'Primary Diagnosis' : row.coding_category}
                                                        options={category}
                                                        label="name"
                                                        handleChange={(val) => {
                                                            const updatedList = event.work_allocation.secondary_diagnostics_qa_feedback?.map(
                                                                (icdRow) =>
                                                                    icdRow.idx === row.idx
                                                                        ? { ...icdRow, coding_category: val, coding_subcategory: '' }
                                                                        : icdRow
                                                            )
                                                            updateEvent({
                                                                work_allocation: {
                                                                    ...event.work_allocation,
                                                                    secondary_diagnostics_qa_feedback: updatedList,
                                                                },
                                                                update_obj: {
                                                                    name: event?.work_allocation?.name,
                                                                    data: {
                                                                        secondary_diagnostics_qa_feedback: updatedList,
                                                                    },
                                                                },
                                                            })
                                                        }}
                                                        onMouseDown={(e) => {
                                                            // Prevent this cell from triggering drag
                                                            e.preventDefault()
                                                        }}
                                                        className="border-none w-full outline-none ring-0 focus-visible:ring-0 shadow-none"
                                                        placeholder="Category"
                                                        nodata_category={row.idx == 1 ? true : false}
                                                    />
                                                </TableCell>
                                                <TableCell className="border border-gray-200 p-0">
                                                    <SearchableDropdown
                                                        selectedVal={row.coding_subcategory}
                                                        options={getSubcategories(row.idx == 1 ? 'Primary Diagnosis' : row.coding_category)}
                                                        label="parent"
                                                        handleChange={(val) => {
                                                            const updatedList = event.work_allocation.secondary_diagnostics_qa_feedback?.map(
                                                                (icdRow) => (icdRow.idx === row.idx ? { ...icdRow, coding_subcategory: val } : icdRow)
                                                            )
                                                            updateEvent({
                                                                work_allocation: {
                                                                    ...event.work_allocation,
                                                                    secondary_diagnostics_qa_feedback: updatedList,
                                                                },
                                                                update_obj: {
                                                                    name: event?.work_allocation?.name,
                                                                    data: {
                                                                        secondary_diagnostics_qa_feedback: updatedList,
                                                                    },
                                                                },
                                                            })
                                                        }}
                                                        onDragStart={(e) => e.stopPropagation()}
                                                        className="border-none w-full outline-none ring-0 focus-visible:ring-0 shadow-none"
                                                        placeholder="Sub Category"
                                                    />
                                                </TableCell>
                                                <TableCell className="border border-gray-200 p-0">
                                                    <Textarea
                                                        className="border-none w-full outline-none ring-0 focus-visible:ring-0"
                                                        onChange={(e) => {
                                                            const updatedList = event.work_allocation.secondary_diagnostics_qa_feedback?.map(
                                                                (icdRow) =>
                                                                    icdRow.idx === row.idx ? { ...icdRow, qa_comments: e.target.value } : icdRow
                                                            )
                                                            updateEvent({
                                                                work_allocation: {
                                                                    ...event.work_allocation,
                                                                    secondary_diagnostics_qa_feedback: updatedList,
                                                                },
                                                                update_obj: {
                                                                    name: event?.work_allocation?.name,
                                                                    data: {
                                                                        secondary_diagnostics_qa_feedback: updatedList,
                                                                    },
                                                                },
                                                            })
                                                        }}
                                                        value={row.qa_comments}
                                                        rows={1}
                                                    />
                                                </TableCell>
                                                <TableCell className="border border-gray-200 p-0 text-center">
                                                    <Checkbox
                                                        className="mx-2 "
                                                        checked={Boolean(row.educational_error)}
                                                        onClick={() =>
                                                            updateEvent({
                                                                work_allocation: {
                                                                    ...event.work_allocation,
                                                                    secondary_diagnostics_qa_feedback:
                                                                        event.work_allocation.secondary_diagnostics_qa_feedback?.map((icd_code_qa) =>
                                                                            icd_code_qa.idx === row.idx
                                                                                ? {
                                                                                      ...icd_code_qa,
                                                                                      educational_error: !icd_code_qa.educational_error,
                                                                                  }
                                                                                : icd_code_qa
                                                                        ),
                                                                },
                                                                update_obj: {
                                                                    name: event?.work_allocation?.name,
                                                                    data: {
                                                                        secondary_diagnostics_qa_feedback:
                                                                            event.work_allocation.secondary_diagnostics_qa_feedback?.map(
                                                                                (icd_code_qa) =>
                                                                                    icd_code_qa.idx === row.idx
                                                                                        ? {
                                                                                              ...icd_code_qa,
                                                                                              educational_error: Boolean(
                                                                                                  !icd_code_qa.educational_error
                                                                                              ),
                                                                                          }
                                                                                        : icd_code_qa
                                                                            ),
                                                                    },
                                                                },
                                                            })
                                                        }
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow colspan={7}>
                                            <TableCell colspan={7}>
                                                <NoDataFound />
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>

                            <Button
                                type="button"
                                className=" hover:bg-gray-200 bg-gray-200 border-gray-800 text-gray-600 text-[12px]"
                                onClick={() => {
                                    updateEvent({
                                        work_allocation: {
                                            ...event.work_allocation,
                                            secondary_diagnostics_qa_feedback: [
                                                ...event?.work_allocation?.secondary_diagnostics_qa_feedback,
                                                {
                                                    idx: parseInt(event.work_allocation.secondary_diagnostics_qa_feedback.length) + 1,
                                                    checkbox: false,
                                                    icd_qa: '',
                                                    coding_category: '',
                                                    coding_subcategory: '',
                                                    qa_comments: '',
                                                    educational_error: false,
                                                    isChanged: false,
                                                },
                                            ],
                                        },
                                    })
                                }}
                            >
                                Add Row
                            </Button>
                            {event.work_allocation.secondary_diagnostics_qa_feedback?.some((row) => row.checkbox) &&
                                !event?.work_allocation.secondary_diagnostics_qa_feedback?.every((row) => row.checkbox) && (
                                    <Button
                                        type="button"
                                        className="bg-primary-red ml-1 font-normal"
                                        onClick={() => {
                                            updateEvent({
                                                work_allocation: {
                                                    ...event.work_allocation,
                                                    secondary_diagnostics_qa_feedback: event.work_allocation.secondary_diagnostics_qa_feedback.filter(
                                                        (row) => !row.checkbox
                                                    ),
                                                },
                                                update_obj: {
                                                    name: event.work_allocation.name,
                                                    data: {
                                                        secondary_diagnostics_qa_feedback:
                                                            event.work_allocation.secondary_diagnostics_qa_feedback.filter((row) => !row.checkbox),
                                                    },
                                                },
                                            })
                                        }}
                                    >
                                        Delete
                                    </Button>
                                )}

                            {event.work_allocation.secondary_diagnostics_qa_feedback?.length > 0 &&
                                event.work_allocation.secondary_diagnostics_qa_feedback.every((row) => row.checkbox) && (
                                    <Button
                                        type="button"
                                        className="bg-primary-red ml-1 font-normal"
                                        onClick={() => {
                                            updateEvent({
                                                work_allocation: {
                                                    ...event.work_allocation,
                                                    secondary_diagnostics_qa_feedback: [],
                                                },
                                                update_obj: {
                                                    name: event.work_allocation.name,
                                                    data: {
                                                        secondary_diagnostics_qa_feedback: [],
                                                    },
                                                },
                                            })
                                        }}
                                    >
                                        Delete All
                                    </Button>
                                )}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <div className="grid grid-cols-2 gap-y-3 gap-x-6 mt-5">
                <FormField
                    control={form.control}
                    name="notepad"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel className="">Notepad</FormLabel>
                            <FormControl>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={event.work_allocation.notepad}
                                    onChange={(e, editor) => {
                                        const content = editor.getData()
                                        field.onChange(content)
                                        console.log('wirk allocation', event.work_allocation.name)

                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                notepad: content,
                                            },
                                            update_obj: {
                                                name: event.work_allocation.name,
                                                data: {
                                                    notepad: content,
                                                },
                                            },
                                        })
                                    }}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="qa_comments"
                    render={({ field }) => (
                        <FormItem className="space-y-1 hidden">
                            <FormLabel>QA Comments</FormLabel>
                            <FormControl>
                                <Textarea
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security hidden"
                                    placeholder="QA Comments"
                                    rows={4}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
            </div>
        </>
    )
}

export default Coding
